module.exports = __webpack_public_path__ + "img/green-save.67e6b421.svg";